
import { makeAutoObservable, runInAction } from 'mobx';
import { IDiscount, IDiscountParams } from 'src/@types/Choqorak/MainTables/Finance/Discount';
import agent from 'src/api/agent';
export default class DiscountStore {
  openDialog = false;

  DiscountRegistry = new Map<number, IDiscount>();

  editMode = false; //When click on edit button

  selectedDiscount: IDiscount | undefined = undefined;

  totalRecord: number = 0;

  constructor() {
    makeAutoObservable(this);
  }

  get DiscountList() {
    return Array.from(this.DiscountRegistry.values());
  }

  setDiscountList = (Discount: IDiscount) => {
    this.DiscountRegistry.set(Discount.id!, Discount);
  };

  

  //Pagination
  loadDiscount = async (params: IDiscountParams) => {
   // this.DiscountRegistry.clear();
    try {
      const result = await agent.Discount.getList(params);
      runInAction(() => {
        this.totalRecord = result.data.totalRecord;
        const reversed=result.data.data.reverse();
        reversed.forEach((lst: any) => {
          this.setDiscountList(lst);
        });
      });
    } catch (error) {
      console.log(error);
    }
  };

  // Search
  DiscountSearch = async (params: IDiscountParams) => {
    //this.DiscountRegistry.clear();
    this.loadDiscount(params);
  };

  getDiscountFromRegistry = (id: number) => {
    let Discount = this.DiscountRegistry.get(id);
    if (Discount) {
      this.editMode = true;
      this.selectedDiscount = Discount;
    }
  };

  clearSelectedDiscount = () => {
    this.editMode = false;
    this.selectedDiscount = undefined;
  };

  deleteDiscount = async (id: number, remark?: string) => {
   
      await agent.Discount.delete(id, remark!);
      runInAction(() => {
        this.DiscountRegistry.delete(id);
        this.totalRecord--;
        this.setOpenCloseDialog();
      });
   
  };

  setOpenCloseDialog = () => (this.openDialog = !this.openDialog);

  createDiscount = async (Discount: IDiscount) => {
    
      await agent.Discount.create(Discount);
      runInAction(() => {
        this.loadDiscount({ pageIndex: 0, pageSize: 5 });
        this.clearSelectedDiscount();
      });
    
  };

  updateDiscount = async (Discount: IDiscount) => {
  
      await agent.Discount.update(Discount);

      runInAction(() => {
        this.loadDiscount({ pageIndex: 0, pageSize: 5 });
        this.DiscountRegistry.delete(Discount.id!);
        this.DiscountRegistry.set(Discount.id!, Discount);
        this.clearSelectedDiscount();

      });
    
  };
}
